<div class="business-account-request">
  <div *ngIf="!state.sectionMiddle.isError">
    <h2 class="sub-header">
      <span tabindex="0"> {{ state.sectionMiddle.tableHeading}} <span
          *ngIf="!state.sectionMiddle.tableState.loading && state.sectionMiddle.tableState.gridData.length > 0">({{state.sectionMiddle.tableState.gridData.length}})</span>
      </span>
    </h2>
    <div class="business-account-request-table">
      <kng-table [state]="state.sectionMiddle.tableState" (tooltipClicked)="showTooltip($event)"
        (btnClickEvent)="approveRejectUser($event)" (editButtonClicked)="openEditAdminCompanyDetailsModal($event)"
        (locationListButton)=downloadLocationListData($event)
        (uploadFileLinkClicked)="openUploadSection($event)"></kng-table>
    </div>
  </div>
  <div class="business-account-request-error" *ngIf="state.sectionMiddle.isError">
    <tmhna-portal-common-error [state]="state.sectionMiddle.errorState"></tmhna-portal-common-error>
  </div>
  <div class="overlay" *ngIf="state.sectionMiddle.loading">
    <kng-loader [state]="loaderState"></kng-loader>
  </div>
</div>

<kng-modal-component class="editAdminCompanyDetailsModal" #editAdminCompanyDetailsModal
  *ngIf="!editAdminCompanyDetailsModalState.hidden" [state]="editAdminCompanyDetailsModalState"
  (ctaClickedOn)="editAdminCompanyDetailsModalEvent($event)">
  <div class="update-admin-error-message" tabindex="0" *ngIf="service.updateAdminDetailsErrorMessage">
    <p>{{service.updateAdminDetailsErrorMessage}}</p>
  </div>
  <div class="edit-admin-company-details--section row">
    <form class="company-details--form" [formGroup]="buildEditDetailsForm">

      <div class="company-details--input-section-1">
        <div class="company-information--input-group col-md-12">
          <label for="companyName">{{ editAdminCompanyDetailsAemLabelsState.pageLabels.companyName.label }}</label>
          <input type="text" name="companyName" id="companyName" maxlength="40" formControlName="accountName"
            (input)="nonNumericSpaceRestriction(buildEditDetailsForm.controls['accountName'].value, 'accountName')"
            [ngClass]="{'form-input-error': validateEditAdminCompanyDetailsForm('accountName') && validateEditForm.accountName}">
          <div *ngIf="validateEditForm.accountName && buildEditDetailsForm.controls['accountName']['errors']"
            class="form-error" role="alert" tabindex="0">
            <div *ngIf="buildEditDetailsForm.controls['accountName']['errors']['required']" class="form-error">
              {{ getRequiredErrorMessage( editAdminCompanyDetailsAemLabelsState.pageLabels.companyName.label) }}
            </div>
            <div *ngIf="buildEditDetailsForm.controls['accountName']['errors']['alphaSpclCharValidationError']">
              {{ editAdminCompanyDetailsAemLabelsState.errorText.invalidCharacterWithNumericErrorMessage }}
            </div>
          </div>
        </div>

        <div class="company-information--input-group col-md-12">
          <label for="addressLine1">{{ editAdminCompanyDetailsAemLabelsState.pageLabels.addressLine1.label }}</label>
          <input type="text" name="addressLine1" id="addressLine1" maxlength="50" formControlName="addressLine1"
            [ngClass]="{'form-input-error': validateEditAdminCompanyDetailsForm('addressLine1') && validateEditForm.addressLine1}">
          <div class="form-error"
            *ngIf="validateEditForm.addressLine1 && buildEditDetailsForm.controls['addressLine1'].errors">
            {{ getRequiredErrorMessage( editAdminCompanyDetailsAemLabelsState.pageLabels.addressLine1.label) }}
          </div>
        </div>

        <div class="company-information--input-group col-md-12">
          <label for="addressLine2">{{
            editAdminCompanyDetailsAemLabelsState.pageLabels.addressLine2.label }}</label>
          <input type="text" name="addressLine2" id="addressLine2" formControlName="addressLine2" maxlength="50">
        </div>
      </div>

      <div class="company-details--input-section-2 col-md-3 country">
        <div class="company-information--input-group">
          <label for="country">{{ editAdminCompanyDetailsAemLabelsState.pageLabels.country.label }}</label>
          <div class="desktop-view">
            <mat-select disableOptionCentering panelClass="myPanelClass" yPosition="below"
              class="form-select statesList" formControlName="country" disableRipple aria-label="country" id="country"
              name="country" (selectionChange)="countryChange($event)"
              [ngClass]="{'form-input-error': validateEditAdminCompanyDetailsForm('country') && validateEditForm.country}">
              <mat-option *ngFor="let country of countries" [value]="country.value">{{country.label}}</mat-option>
            </mat-select>
          </div>

          <div class="mobile-view">
            <select class="form-select statesList" aria-label="country" formControlName="country" name="country"
              (ngModelChange)="countryChange($event)"
              [ngClass]="{'form-input-error': validateEditAdminCompanyDetailsForm('country') && validateEditForm.country}">
              <option *ngFor="let country of countries" [ngValue]="country.value">{{country.label}}</option>
            </select>
          </div>
          <div class="form-error" *ngIf="validateEditForm.country && buildEditDetailsForm.controls['country'].errors">
            {{getRequiredErrorMessage(editAdminCompanyDetailsAemLabelsState.pageLabels.country.label)}}
          </div>
        </div>

        <div class="company-information--input-group city">
          <label for="city">{{ editAdminCompanyDetailsAemLabelsState.pageLabels.city.label }}</label>
          <input type="text" name="city" id="city" maxlength="50" formControlName="city"
            (input)="nonNumericSpaceRestriction(buildEditDetailsForm.controls['city'].value, 'city')"
            [ngClass]="{'form-input-error': validateEditAdminCompanyDetailsForm('city') && validateEditForm.city}">
          <div *ngIf="validateEditForm.city && buildEditDetailsForm.controls['city'].errors" class="form-error"
            role="alert">
            <div *ngIf="buildEditDetailsForm.controls['city'].errors['required']">
              {{getRequiredErrorMessage(editAdminCompanyDetailsAemLabelsState.pageLabels.city.label)}}
            </div>
            <div *ngIf="buildEditDetailsForm.controls['city'].errors['alphaSpclCharValidationError']">
              {{ editAdminCompanyDetailsAemLabelsState.errorText.invalidCharacterWithoutNumericErrorMessage }}
            </div>
          </div>
        </div>

        <div class="company-information--input-group state">
          <label for="state">{{ editAdminCompanyDetailsAemLabelsState.pageLabels.state.label }}</label>
          <div class="desktop-view">
            <mat-select disableOptionCentering panelClass="statePanelClass" yPosition="below"
              class="form-select statesList" disableRipple formControlName="state" aria-label="state"
              [value]="service.buildEditDetailsForm.controls['state'].value"
              [ngClass]="{'form-input-error': validateEditAdminCompanyDetailsForm('state') && validateEditForm.state}">
              <mat-option *ngFor="let state of statesValue" [value]="state.value">
                {{ state.label }}
              </mat-option>
            </mat-select>
          </div>
          <div class="mobile-view">
            <select class="form-select statesList" aria-label="state" aria-label="state" formControlName="state"
              [ngClass]="{'form-input-error': validateEditAdminCompanyDetailsForm('state') && validateEditForm.state}">
              <option *ngFor="let state of statesValue" [value]="state.value">
                {{ state.label }}
              </option>
            </select>
          </div>
          <div class="form-error" *ngIf="validateEditForm.state && buildEditDetailsForm.controls['state'].errors"
            role="alert">
            {{ getRequiredErrorMessage(editAdminCompanyDetailsAemLabelsState.pageLabels.state.label) }}
          </div>
        </div>

        <div class="company-information--input-group zipCode">
          <label for="zipCode">{{ editAdminCompanyDetailsAemLabelsState.pageLabels.zipCode.label }}</label>
          <input type="text" name="zipCode" id="zipCode" formControlName="postalCode" maxlength="10"
            (input)="formatZipCode(buildEditDetailsForm.controls['postalCode'].value)"
            [ngClass]="{'form-input-error': validateEditAdminCompanyDetailsForm('postalCode') && validateEditForm.postalCode}">
          <div class="form-error" role="alert"
            *ngIf="validateEditForm.postalCode && buildEditDetailsForm.controls['postalCode'].errors">
            <div
              *ngIf="buildEditDetailsForm.controls['postalCode'].errors['required'] || buildEditDetailsForm.controls['postalCode'].errors['whitespace']">
              {{getRequiredErrorMessage(editAdminCompanyDetailsAemLabelsState.pageLabels.zipCode.label)}}
            </div>
            <div *ngIf="buildEditDetailsForm.controls['postalCode'].errors['minLengthError']">
              {{ editAdminCompanyDetailsAemLabelsState.errorText.minLengthZipCodeError }}
            </div>
            <div *ngIf="buildEditDetailsForm.controls['postalCode'].errors['canadaPostalCodeFormatError']">
              {{ editAdminCompanyDetailsAemLabelsState.errorText.canadaPostalCodeFormatError }}
            </div>
          </div>

        </div>
      </div>

    </form>
  </div>
</kng-modal-component>
<kng-modal-component #uploadFile *ngIf="!service.uploadModelState.hidden" [state]="service.uploadModelState"
  (closed)="closeModalUpload()" (ctaClickedOn)="uploadFileModalBtnEvent($event)" class="uploadFile">
  <div class="subHeading">
    <p tabindex="0"> {{ service.uploadModelSubheading }} </p>
  </div>
  <kng-upload-file #fileUploadComponent [state]="service.uploadFileState"
    (fileValidationCheck)="fileValidationCheck($event)" (tryAgainEventEmitter)="uploadFileServerValidation($event)"
    (replaceFileEventEmitter)="replaceFileEventEmitter()">
  </kng-upload-file>
</kng-modal-component>
